const AuthButton = ({ providerIcon, providerName, onClick }) => {
  return (
    <button className="boton-login" onClick={onClick}>
      {providerIcon}
      <span>Continue with {providerName}</span>
    </button>
  );
};

export default AuthButton;